import React, { useEffect, useState, useRef } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { toast } from "react-hot-toast";
import { useNavigate, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import ReCAPTCHA from "react-google-recaptcha";
import "react-phone-number-input/style.css";

import Header from "../../HomePage/Header/Header";
import Footer from "../../HomePage/Footer/Footer";
import FeedbackForm from "../../FeedbackForm/FeedbackForm";
import HourglassLoader from "../../../Common/HourglassLoader";

import {
  getCountryData,
  getStateData,
  getCityData,
} from "../../../Redux/action/MasterAction";

const host = process.env.REACT_APP_API_SERVER;
const siteKey = process.env.REACT_APP_SITE_KEY;

const StudentRegister = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const captchaRef = useRef(null);

  const [captchaToken, setCaptchaToken] = useState(null);
  const [captchaError, setCaptchaError] = useState("");
  const [faIcon, setfaIcon] = useState("fa-eye-slash");
  const [faIcon1, setfaIcon1] = useState("fa-eye-slash");

  useEffect(() => {
    dispatch(getCountryData());
  }, [dispatch]);

  const togglePasswordType = () => {
    let input_pass = document.getElementById("password-field");
    let input_type = input_pass.getAttribute("type");
    if (input_type === "password") {
      setfaIcon("fa-eye");
      input_pass.type = "text";
    } else {
      setfaIcon("fa-eye-slash");
      input_pass.type = "password";
    }
  };

  const togglePasswordType1 = () => {
    let input_pass = document.getElementById("password-field_1");
    let input_type = input_pass.getAttribute("type");
    if (input_type === "password") {
      setfaIcon1("fa-eye");
      input_pass.type = "text";
    } else {
      setfaIcon1("fa-eye-slash");
      input_pass.type = "password";
    }
  };

  const {
    CountryDataListApiData,
    StateDataListApiData,
    CityDataListApiData,
  } = useSelector((state) => state.MasterReducer);

  const formik = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      country_code: "",
      mobile: "",
      email: "",
      dob: "",
      gender: "",
      password: "",
      cpassword: "",
      about_the_tutor: "",
      country_id: "",
      state_id: "",
      city_id: "",
      address_line_1: "",
      address_line_2: "",
      zip_code: "",
    },
    validationSchema: Yup.object({
      firstName: Yup.string()
        .required("First name is required")
        .matches(/^[a-zA-Z .]+$/, "Name can only contain letters."),
      lastName: Yup.string().matches(/^[a-zA-Z .]+$/, "Name can only contain letters."),
      email: Yup.string()
        .required("Email is required.")
        .matches(
          /^\w+[-\.\w]*@(?!(?:)\.com$)\w+[-\.\w]*?\.\w{2,4}$/,
          "Enter a valid E-mail"
        ),
      mobile: Yup.string()
        .required("Phone number is required")
        .matches(/^[1-9][0-9]{7,14}$/, "Please enter a valid Mobile Number."),
      country_code: Yup.string().required("Country Code is required"),
      password: Yup.string()
        .required("Password is required")
        .min(6, "Password must be at least 6 characters long"),
      cpassword: Yup.string()
        .oneOf([Yup.ref("password"), null], "Passwords must match")
        .required("Confirm password is required"),
      zip_code: Yup.string(),
    }),
    onSubmit: async (values, { setSubmitting }) => {
      try {
        if (!captchaToken) {
          setCaptchaError("Please complete the CAPTCHA.");
          return;
        }

        setSubmitting(true);
        
        const [country, phoneCode] = values.country_code.split("_");
        const formData = new FormData();
        formData.append("name", `${values.firstName} ${values.lastName}`);
        formData.append("email", values.email);
        formData.append("country_code", phoneCode);
        formData.append("mobile", values.mobile);
        formData.append("dob", values.dob);
        formData.append("gender", values.gender);
        formData.append("password", values.password);
        formData.append("about_the_tutor", values.about_the_tutor);
        formData.append("country_id", values.country_id);
        formData.append("state_id", values.state_id);
        formData.append("city_id", values.city_id);
        formData.append("address_line_1", values.address_line_1);
        formData.append("address_line_2", values.address_line_2);
        formData.append("zip_code", values.zip_code);
        formData.append("captchaToken", captchaToken);

        const config = {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        };

        const res = await axios.post(`${host}/api/web/student-register`, formData, config);

        if (res.status === 200) {
          toast.success(res.data.message);
          navigate("/student/login", { state: { user: "student" } });
        } else {
          if (captchaRef.current) {
            captchaRef.current.reset();
          }
          setCaptchaToken(null);
          toast.error(res.data.message);
        }
      } catch (err) {
        if (captchaRef.current) {
          captchaRef.current.reset();
        }
        setCaptchaToken(null);
        if (err.response) {
          toast.error(err.response.data.message);
        } else {
          toast.error("Internal server error.");
        }
      } finally {
        setSubmitting(false);
      }
    },
  });

  const handleCountryChange = (e) => {
    const id = e.target.value;
    formik.setFieldValue("state_id", "");
    formik.setFieldValue("city_id", "");

    if (id === "") {
      dispatch(getStateData("0"));
    } else {
      dispatch(getStateData(id));
    }
    dispatch(getCityData(0));
  };

  const handleStateChange = (e) => {
    const id = e.target.value;
    formik.setFieldValue("city_id", "");
    if (id === "") {
      dispatch(getCityData("0"));
    } else {
      dispatch(getCityData(id));
    }
  };

  const handleCaptcha = (token) => {
    setCaptchaToken(token);
    setCaptchaError("");
  };

  return (
    <>
      <FeedbackForm />
      <Header />

      {/* Using exactly the same background classes as login page */}
      <div className="login-background">
        <div className="login-main-container login-main-container-std">
          <div className="row login-form-part">
            <div className="card login-form" style={{ maxWidth: "850px", margin: "0 auto" }}>
              <div className="form-body">
                <form onSubmit={formik.handleSubmit} method="post">
                  <h4 className="text-center mb-4 fw-bold">
                    Student Registration
                  </h4>

                  <div className="row mb-3 p-4">
                    {/* First Name */}
                    <div className="col-lg-6 col-md-6 col-sm-12 mb-3">
                      <label htmlFor="first_name" className="form-label">
                        First Name<span className="text-danger">*</span>
                      </label>
                      <input
                        maxLength={20}
                        type="text"
                        className="input-form"
                        id="first_name"
                        placeholder="Enter your full name"
                        name="firstName"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.firstName}
                      />
                      <div className="help-block with-errors">
                        {formik.touched.firstName && formik.errors.firstName ? (
                          <div className="text-danger">
                            {formik.errors.firstName}
                          </div>
                        ) : null}
                      </div>
                    </div>

                    {/* Last Name */}
                    <div className="col-lg-6 col-md-6 col-sm-12 mb-3">
                      <label htmlFor="last_name" className="form-label">
                        Last Name
                      </label>
                      <input
                        maxLength={20}
                        type="text"
                        className="input-form"
                        id="last_name"
                        placeholder="Enter your last name"
                        name="lastName"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.lastName}
                      />
                      <div className="help-block with-errors">
                        {formik.touched.lastName && formik.errors.lastName ? (
                          <div className="text-danger">{formik.errors.lastName}</div>
                        ) : null}
                      </div>
                    </div>

                    {/* Phone Number */}
                    <div className="col-lg-6 col-md-6 col-sm-12 mb-3">
                      <label htmlFor="mobile" className="form-label">
                        Phone Number<span className="text-danger">*</span>
                      </label>
                      <div className="row">
                        <div className="col-md-5">
                          <select
                            className="form-select"
                            name="country_code"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.country_code}
                          >
                            <option value="">--Select--</option>
                            {CountryDataListApiData?.map((data) => (
                              <option
                                key={data.sort_name}
                                value={`${data.sort_name}_${data.phone_code}`}
                              >
                                {data?.sort_name} ({data?.phone_code})
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="col-md-7">
                          <input
                            maxLength={12}
                            type="text"
                            className="input-form"
                            id="mobile"
                            placeholder="Enter your phone number"
                            name="mobile"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.mobile}
                          />
                        </div>
                      </div>
                      <div className="help-block with-errors">
                        {formik.touched.mobile && formik.errors.mobile ? (
                          <div className="text-danger">{formik.errors.mobile}</div>
                        ) : null}
                      </div>
                    </div>

                    {/* Email */}
                    <div className="col-lg-6 col-md-6 col-sm-12 mb-3">
                      <label htmlFor="email" className="form-label">
                        Email ID<span className="text-danger">*</span>
                      </label>
                      <input
                        maxLength={100}
                        type="email"
                        autoComplete="off"
                        className="input-form"
                        id="email"
                        placeholder="Enter your email Id"
                        name="email"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.email}
                      />
                      <div className="help-block with-errors">
                        {formik.touched.email && formik.errors.email ? (
                          <div className="text-danger">{formik.errors.email}</div>
                        ) : null}
                      </div>
                    </div>

                    {/* Date of Birth */}
                    <div className="col-lg-6 col-md-6 col-sm-12 mb-3">
                      <label htmlFor="dob" className="form-label">
                        Date of birth
                      </label>
                      <input
                        type="date"
                        className="input-form"
                        id="dob"
                        placeholder="Enter your dob"
                        name="dob"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.dob}
                        max={new Date().toISOString().split("T")[0]}
                        onKeyDown={(e) => e.preventDefault()}
                      />
                      <div className="help-block with-errors">
                        {formik.touched.dob && formik.errors.dob ? (
                          <div className="text-danger">{formik.errors.dob}</div>
                        ) : null}
                      </div>
                    </div>

                    {/* Gender */}
                    <div className="col-lg-6 col-md-6 col-sm-12 mb-3">
                      <label htmlFor="gender" className="form-label">
                        Gender
                      </label>
                      <select
                        name="gender"
                        id="gender"
                        className="form-select"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.gender}
                      >
                        <option value="">-Select-</option>
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                        <option value="Other">Other</option>
                      </select>
                      <div className="help-block with-errors">
                        {formik.touched.gender && formik.errors.gender ? (
                          <div className="text-danger">{formik.errors.gender}</div>
                        ) : null}
                      </div>
                    </div>

                    {/* Password */}
                    <div className="col-lg-6 col-md-6 col-sm-12 mb-3">
                      <label htmlFor="password-field" className="form-label">
                        Password<span className="text-danger">*</span>
                      </label>
                      <div className="input-group">
                        <input
                          maxLength={10}
                          placeholder="Enter Your Password"
                          id="password-field"
                          type="password"
                          className="input-form"
                          name="password"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.password}
                        />
                        <i
                          toggle="#password-field"
                          className={`fa-regular ${faIcon} field-icon toggle-password`}
                          id="toggle_pass"
                          onClick={togglePasswordType}
                        />
                      </div>
                      <div className="help-block with-errors">
                        {formik.touched.password && formik.errors.password ? (
                          <div className="text-danger">
                            {formik.errors.password}
                          </div>
                        ) : null}
                      </div>
                    </div>

                    {/* Confirm Password */}
                    <div className="col-lg-6 col-md-6 col-sm-12 mb-3">
                      <label htmlFor="password-field_1" className="form-label">
                        Confirm Password<span className="text-danger">*</span>
                      </label>
                      <div className="input-group">
                        <input
                          maxLength={10}
                          placeholder="Confirm Password"
                          id="password-field_1"
                          type="password"
                          className="input-form"
                          name="cpassword"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.cpassword}
                        />
                        <i
                          toggle="#password-field_1"
                          className={`fa-regular ${faIcon1} field-icon toggle-password`}
                          id="toggle_pass_1"
                          onClick={togglePasswordType1}
                        />
                      </div>
                      <div className="help-block with-errors">
                        {formik.touched.cpassword && formik.errors.cpassword ? (
                          <div className="text-danger">
                            {formik.errors.cpassword}
                          </div>
                        ) : null}
                      </div>
                    </div>

                    {/* Address Line 1 */}
                    <div className="col-lg-6 col-md-6 col-sm-12 mb-3">
                      <label htmlFor="address_line_1" className="form-label">
                        Address Line-1
                      </label>
                      <input
                        maxLength={100}
                        type="text"
                        className="input-form"
                        id="address_line_1"
                        placeholder="Enter your address line-1"
                        name="address_line_1"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.address_line_1}
                      />
                      <div className="help-block with-errors">
                        {formik.touched.address_line_1 && formik.errors.address_line_1 ? (
                          <div className="text-danger">
                            {formik.errors.address_line_1}
                          </div>
                        ) : null}
                      </div>
                    </div>

                    {/* Address Line 2 */}
                    <div className="col-lg-6 col-md-6 col-sm-12 mb-3">
                      <label htmlFor="address_line_2" className="form-label">
                        Address Line-2
                      </label>
                      <input
                        maxLength={100}
                        type="text"
                        className="input-form"
                        id="address_line_2"
                        placeholder="Enter your address line-2"
                        name="address_line_2"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.address_line_2}
                      />
                      <div className="help-block with-errors">
                        {formik.touched.address_line_2 && formik.errors.address_line_2 ? (
                          <div className="text-danger">
                            {formik.errors.address_line_2}
                          </div>
                        ) : null}
                      </div>
                    </div>

                    {/* Country */}
                    <div className="col-lg-6 col-md-6 col-sm-12 mb-3">
                      <label htmlFor="country_id" className="form-label">
                        Country
                      </label>
                      <select
                        name="country_id"
                        id="country_id"
                        className="form-select"
                        onChange={(e) => {
                          formik.handleChange(e);
                          handleCountryChange(e);
                        }}
                        onBlur={formik.handleBlur}
                        value={formik.values.country_id}
                      >
                        <option value="">--Select Country--</option>
                        {CountryDataListApiData?.map((data) => (
                          <option key={data.id} value={data?.id}>
                            {data?.name}
                          </option>
                        ))}
                      </select>
                      <div className="help-block with-errors">
                        {formik.touched.country_id && formik.errors.country_id ? (
                          <div className="text-danger">
                            {formik.errors.country_id}
                          </div>
                        ) : null}
                      </div>
                    </div>

                    {/* State */}
                    <div className="col-lg-6 col-md-6 col-sm-12 mb-3">
                      <label htmlFor="state_id" className="form-label">
                        State
                      </label>
                      <select
                        name="state_id"
                        id="state_id"
                        className="form-select"
                        onChange={(e) => {
                          formik.handleChange(e);
                          handleStateChange(e);
                        }}
                        onBlur={formik.handleBlur}
                        value={formik.values.state_id}
                      >
                        <option value="">--Select State--</option>
                        {StateDataListApiData?.map((data) => (
                          <option key={data.id} value={data?.id}>
                            {data?.name}
                          </option>
                        ))}
                      </select>
                      <div className="help-block with-errors">
                        {formik.touched.state_id && formik.errors.state_id ? (
                          <div className="text-danger">{formik.errors.state_id}</div>
                        ) : null}
                      </div>
                    </div>

                    {/* City */}
                    <div className="col-lg-6 col-md-6 col-sm-12 mb-3">
                      <label htmlFor="city_id" className="form-label">
                        City
                      </label>
                      <select
                        name="city_id"
                        id="city_id"
                        className="form-select"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.city_id}
                      >
                        <option value="">--Select City--</option>
                        {CityDataListApiData?.map((data) => (
                          <option key={data.id} value={data?.id}>
                            {data?.name}
                          </option>
                        ))}
                      </select>
                      <div className="help-block with-errors">
                        {formik.touched.city_id && formik.errors.city_id ? (
                          <div className="text-danger">{formik.errors.city_id}</div>
                        ) : null}
                      </div>
                    </div>

                    {/* Zip Code */}
                    <div className="col-lg-6 col-md-6 col-sm-12 mb-3">
                      <label htmlFor="student_zip_code" className="form-label">
                        Zip code
                      </label>
                      <input
                        type="text"
                        className="input-form"
                        id="student_zip_code"
                        placeholder="Enter your zip code"
                        name="zip_code"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.zip_code}
                        maxLength={6}
                        minLength={4}
                      />
                      <div className="help-block with-errors">
                        {formik.touched.zip_code && formik.errors.zip_code ? (
                          <div className="text-danger">{formik.errors.zip_code}</div>
                        ) : null}
                      </div>
                    </div>

                    {/* Recaptcha */}
                    <div className="col-12 mb-3">
                      <ReCAPTCHA
                        sitekey={siteKey}
                        onChange={handleCaptcha}
                        ref={captchaRef}
                      />
                      {captchaError && (
                        <div className="text-danger mt-2">{captchaError}</div>
                      )}
                    </div>
                  </div>

                  {/* Submit Button */}
                  <div className="mb-3 row">
                    <div className="col-sm-12 mb-3 text-center">
                      <button
                        type="submit"
                        disabled={formik.isSubmitting}
                        className="login-btn fw-bold"
                        style={{ color: "white !important" }}
                      >
                        {formik.isSubmitting ? <HourglassLoader /> : "Register"}
                      </button>
                    </div>
                  </div>

                  {/* Login Link */}
                  <div className="log-undre-text text-center my-2">
                    <p>
                      Already a user?
                      <Link to="/student/login">
                        <span> Login</span>
                      </Link>
                    </p>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default StudentRegister;